module.exports = __webpack_public_path__ + "static/media/ContasPagRec2.fa037619.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelContasPagRec/ContasPagRec2.png
// module id = 2012
// module chunks = 0